import React from 'react';
import type { RegistryApproval } from '../../api/registryApiTypes';
import { ConfirmDialog } from '../../ui/feedback';

export interface PendingDecision {
  item: RegistryApproval;
  approve: boolean;
}

/** Confirms an approve or reject; rejecting needs a reason. */
export default function DecisionDialog({
  decision,
  onClose,
  onConfirm,
}: {
  decision: PendingDecision | null;
  onClose: () => void;
  onConfirm: (decision: PendingDecision, comment?: string) => void;
}) {
  const approve = decision?.approve ?? false;
  const isTest = decision?.item.kind === 'TEST';
  return (
    <ConfirmDialog
      open={Boolean(decision)}
      title={`${approve ? 'Approve' : 'Reject'}: ${decision?.item.title ?? ''}`}
      body={
        isTest
          ? 'This is a test request: deciding it is recorded, but changes nothing else.'
          : approve
            ? 'Approving applies the change straight away.'
            : 'The request returns to the person who raised it, with your reason.'
      }
      confirmLabel={approve ? 'Approve' : 'Reject'}
      danger={!approve}
      requireComment={!approve}
      commentLabel={approve ? 'Comment (optional)' : 'Reason'}
      onClose={onClose}
      onConfirm={(comment) => {
        if (decision) onConfirm(decision, comment);
      }}
    />
  );
}
